import type {HomeMatchConfigurationSourceSection} from "@pg-rp/common-types";

import {IApplicationPayload} from "../../../applications/types/IApplicationPayload";
import {UserAmplitudePhoneVerifiedLocation} from "../../../tracking/amplitude/user_amplitude_tracker";

export enum PhoneVerificationPendingActionType {
    // SMS only: executor has no side-effect; the entry point resumes locally via completion hook (thumb-up, unlock, passive prompt).
    NONE = "none",
    LEAD_SEND = "lead_send",
    HM_ACTIVATION = "hm_activation",
    REGISTRATION_ONBOARDING = "registration_onboarding"
}

export interface IHomeMatchActivationIntent {
    isActive: boolean;
    syncCplPreferences: boolean;
    sourceSection?: HomeMatchConfigurationSourceSection;
    showSuccessNotification?: boolean;
}

export enum PhoneVerificationFlowOutcomeKind {
    COMPLETED = "completed",
    DISMISSED = "dismissed"
}

export type IPhoneVerificationFlowOutcome =
    | {kind: PhoneVerificationFlowOutcomeKind.COMPLETED; type: PhoneVerificationPendingActionType; success: boolean}
    | {kind: PhoneVerificationFlowOutcomeKind.DISMISSED; type: PhoneVerificationPendingActionType};

type INonePendingAction = {type: PhoneVerificationPendingActionType.NONE};
export type ILeadSendPendingAction = {type: PhoneVerificationPendingActionType.LEAD_SEND; leadPayload: IApplicationPayload};
type IHmActivationPendingAction = {type: PhoneVerificationPendingActionType.HM_ACTIVATION; hmActivationIntent: IHomeMatchActivationIntent};
type IRegistrationOnboardingPendingAction = {
    type: PhoneVerificationPendingActionType.REGISTRATION_ONBOARDING;
    location: UserAmplitudePhoneVerifiedLocation;
};

export type IPhoneVerificationPendingAction = INonePendingAction | ILeadSendPendingAction | IHmActivationPendingAction | IRegistrationOnboardingPendingAction;

export interface IRequestPhoneVerificationPayload {
    pendingAction: IPhoneVerificationPendingAction;
    awaitCompletion?: boolean;
}

export const PHONE_VERIFICATION_PENDING_ACTION_NONE: IPhoneVerificationPendingAction = {
    type: PhoneVerificationPendingActionType.NONE
};

export const createDefaultHmActivationIntent = (overrides: Partial<IHomeMatchActivationIntent> = {}): IHomeMatchActivationIntent => ({
    isActive: true,
    syncCplPreferences: true,
    showSuccessNotification: true,
    ...overrides
});

export const createLeadSendPendingAction = (leadPayload: IApplicationPayload): ILeadSendPendingAction => ({
    type: PhoneVerificationPendingActionType.LEAD_SEND,
    leadPayload
});

export const createHmActivationPendingAction = (hmActivationIntent: IHomeMatchActivationIntent): IHmActivationPendingAction => ({
    type: PhoneVerificationPendingActionType.HM_ACTIVATION,
    hmActivationIntent
});

export const createRegistrationOnboardingPendingAction = (location: UserAmplitudePhoneVerifiedLocation): IRegistrationOnboardingPendingAction => ({
    type: PhoneVerificationPendingActionType.REGISTRATION_ONBOARDING,
    location
});
import type {HomeMatchConfigurationSourceSection} from "@pg-rp/common-types";

import {IApplicationPayload} from "../../../applications/types/IApplicationPayload";
import {UserAmplitudePhoneVerifiedLocation} from "../../../tracking/amplitude/user_amplitude_tracker";

export enum PhoneVerificationPendingActionType {
    // SMS only: executor has no side-effect; the entry point resumes locally via completion hook (thumb-up, unlock, passive prompt).
    NONE = "none",
    LEAD_SEND = "lead_send",
    HM_ACTIVATION = "hm_activation",
    REGISTRATION_ONBOARDING = "registration_onboarding"
}

export interface IHomeMatchActivationIntent {
    isActive: boolean;
    syncCplPreferences: boolean;
    sourceSection?: HomeMatchConfigurationSourceSection;
    showSuccessNotification?: boolean;
}

export enum PhoneVerificationFlowOutcomeKind {
    COMPLETED = "completed",
    DISMISSED = "dismissed"
}

export type IPhoneVerificationFlowOutcome =
    | {kind: PhoneVerificationFlowOutcomeKind.COMPLETED; type: PhoneVerificationPendingActionType; success: boolean}
    | {kind: PhoneVerificationFlowOutcomeKind.DISMISSED; type: PhoneVerificationPendingActionType};

type INonePendingAction = {type: PhoneVerificationPendingActionType.NONE};
export type ILeadSendPendingAction = {type: PhoneVerificationPendingActionType.LEAD_SEND; leadPayload: IApplicationPayload};
type IHmActivationPendingAction = {type: PhoneVerificationPendingActionType.HM_ACTIVATION; hmActivationIntent: IHomeMatchActivationIntent};
type IRegistrationOnboardingPendingAction = {
    type: PhoneVerificationPendingActionType.REGISTRATION_ONBOARDING;
    location: UserAmplitudePhoneVerifiedLocation;
};

export type IPhoneVerificationPendingAction = INonePendingAction | ILeadSendPendingAction | IHmActivationPendingAction | IRegistrationOnboardingPendingAction;

export interface IRequestPhoneVerificationPayload {
    pendingAction: IPhoneVerificationPendingAction;
    awaitCompletion?: boolean;
}

export const PHONE_VERIFICATION_PENDING_ACTION_NONE: IPhoneVerificationPendingAction = {
    type: PhoneVerificationPendingActionType.NONE
};

export const createDefaultHmActivationIntent = (overrides: Partial<IHomeMatchActivationIntent> = {}): IHomeMatchActivationIntent => ({
    isActive: true,
    syncCplPreferences: true,
    showSuccessNotification: true,
    ...overrides
});

export const createLeadSendPendingAction = (leadPayload: IApplicationPayload): ILeadSendPendingAction => ({
    type: PhoneVerificationPendingActionType.LEAD_SEND,
    leadPayload
});

export const createHmActivationPendingAction = (hmActivationIntent: IHomeMatchActivationIntent): IHmActivationPendingAction => ({
    type: PhoneVerificationPendingActionType.HM_ACTIVATION,
    hmActivationIntent
});

export const createRegistrationOnboardingPendingAction = (location: UserAmplitudePhoneVerifiedLocation): IRegistrationOnboardingPendingAction => ({
    type: PhoneVerificationPendingActionType.REGISTRATION_ONBOARDING,
    location
});
